import React from "react";
import { Row, Col, Placeholder, ProgressBar } from "react-bootstrap";
import MainCard from "../Cards/MainCard";

const AgentProfileScoreCardSkeleton = () => {
  return (
    <MainCard>
      <div className="p-3">
        {/* --- Header Section Skeleton --- */}
        <Row className="align-items-start mb-3 text-center gap-2 gap-sm-0 text-sm-start">
          <Col xs={12} sm={8}>
            <div className="d-flex align-items-center justify-content-center justify-content-sm-start">
              <div className="bg-light p-1 rounded me-2">
                <Placeholder
                  as="div"
                  animation="glow"
                  className="rounded-circle"
                  style={{ width: 50, height: 50 }}
                />
              </div>
              <div>
                <Placeholder as="h5" animation="glow">
                  <Placeholder xs={6} />
                </Placeholder>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={4} />
                </Placeholder>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={4} className="text-center text-sm-end">
            <Placeholder as="h4" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
            <Placeholder as="small" animation="glow">
              <Placeholder xs={3} />
            </Placeholder>
          </Col>
        </Row>

        {/* --- Rebook Rate & Avg Rating Skeleton --- */}
        <Row className="mb-3 gx-4">
          <Col xs={12} sm={6} className="mb-3 mb-sm-0">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <Placeholder as="small" animation="glow">
                <Placeholder xs={5} />
              </Placeholder>
              <Placeholder as="span" animation="glow">
                <Placeholder xs={3} />
              </Placeholder>
            </div>
            <ProgressBar
              now={50}
              variant="secondary"
              style={{ height: "6px", borderRadius: "3px" }}
              animated
              striped
            />
          </Col>
          <Col xs={12} sm={6}>
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <Placeholder as="small" animation="glow">
                <Placeholder xs={5} />
              </Placeholder>
              <Placeholder as="span" animation="glow">
                <Placeholder xs={3} />
              </Placeholder>
            </div>
            <ProgressBar
              now={70}
              variant="secondary"
              style={{ height: "6px", borderRadius: "3px" }}
              animated
              striped
            />
          </Col>
        </Row>

        {/* --- Response Time & Reviews Skeleton --- */}
        <Row className="gx-4 mt-4 gap-2 gap-sm-0">
          <Col
            xs={12}
            sm={6}
            className="d-flex align-items-center justify-content-between"
          >
            <Placeholder as="small" animation="glow">
              <Placeholder xs={6} />
            </Placeholder>
            <Placeholder as="h5" animation="glow">
              <Placeholder xs={3} />
            </Placeholder>
          </Col>

          <Col
            xs={12}
            sm={6}
            className="d-flex align-items-center justify-content-between"
          >
            <Placeholder as="small" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
            <Placeholder as="h5" animation="glow">
              <Placeholder xs={3} />
            </Placeholder>
          </Col>
        </Row>
      </div>
    </MainCard>
  );
};

export default AgentProfileScoreCardSkeleton;
